import { useNavigate } from "react-router-dom";
import { PricingPlanCard } from "./pricing/PricingPlanCard";
import { MobilePricingTable } from "./pricing/MobilePricingTable";

export const PricingPlans = () => {
  const navigate = useNavigate();

  const freePlanFeatures = [
    "Visibilidade Limitada às Primeiras 20 Oportunidades",
    "Acesso Total ao Diretório Artístico Português",
    "1 Candidatura por Mês",
    "Perfil Básico no Diretório Artístico",
    "Upload de Projetos no Portfólio",
  ];

  const freePlanRestrictedFeatures = [
    "Distintivo de Artista Profissional Certificado (NFT)",
    "Visualização Completa dos Detalhes do Diretor de Casting",
    "Opções Avançadas de Filtragem",
    "Visibilidade Aumentada do Perfil",
    "Dashboard com Análise de Exposição",
    "Recursos Extra de Exposição",
    "Monetização de Trabalho Digital",
  ];

  const monthlyPlanFeatures = [
    "Visibilidade Total das Oportunidades",
    "Acesso Total ao Diretório Artístico Português",
    "15 Créditos de Candidatura por Mês",
    "Perfil Verificado com Tag 'Disponível'",
    "Upload de Projetos ou Oportunidades no Portfólio",
    "Distintivo de Artista Profissional Certificado (NFT)",
    "Visualização Completa dos Detalhes do Diretor de Casting",
    "Opções Avançadas de Filtragem",
    "Visibilidade Aumentada do Perfil",
    "Dashboard com Análise de Exposição",
    "Recursos Extra de Exposição",
    "Monetização de Trabalho Digital",
  ];

  const yearlyPlanFeatures = [
    "Visibilidade Total das Oportunidades",
    "Acesso Total ao Diretório Artístico Português",
    "180 Créditos de Candidatura por Ano",
    "Perfil Verificado com Tag 'Disponível'",
    "Upload de Projetos ou Oportunidades no Portfólio",
    "Distintivo de Artista Profissional Certificado (NFT)",
    "Visualização Completa dos Detalhes do Diretor de Casting",
    "Opções Avançadas de Filtragem",
    "Visibilidade Aumentada do Perfil",
    "Dashboard com Análise de Exposição",
    "Recursos Extra de Exposição",
    "Monetização de Trabalho Digital",
  ];

  const handleSubscribe = () => {
    navigate('/signup');
  };

  const plans = [
    {
      title: "Plano Gratuito",
      description: "Para Testar",
      price: "€0",
      period: "/mês",
      features: freePlanFeatures,
      restrictedFeatures: freePlanRestrictedFeatures,
      buttonText: "Começar Gratuitamente",
      buttonClassName: "bg-gray-500 hover:bg-gray-600",
      onSubscribe: handleSubscribe,
    },
    {
      title: "Acesso Mensal",
      description: "Perfeito para Profissionais das Artes e Cultura em Portugal",
      price: "€4.99",
      period: "/mês",
      features: monthlyPlanFeatures,
      buttonText: "Começar Agora",
      buttonClassName: "bg-amber-500 hover:bg-amber-600",
      checkColor: "text-amber-500",
      onSubscribe: handleSubscribe,
    },
    {
      title: "Acesso Anual",
      description: "Economize 50% com faturamento anual",
      price: "€29.95",
      period: "/ano",
      features: yearlyPlanFeatures,
      buttonText: "Economize 50% Agora",
      buttonClassName: "bg-amber-500 hover:bg-amber-600",
      checkColor: "text-amber-500",
      isBestValue: true,
      onSubscribe: handleSubscribe,
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Escolhe o Teu Plano
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Conecta-te com toda a comunidade artística portuguesa e acede a oportunidades exclusivas
          </p>
        </div>

        {/* Mobile/Tablet View */}
        <div className="lg:hidden">
          <MobilePricingTable plans={plans} />
        </div>

        {/* Desktop View */}
        <div className="hidden lg:grid lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {plans.map((plan, index) => (
            <PricingPlanCard key={index} {...plan} />
          ))}
        </div>
      </div>
    </section>
  );
};